function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import Chip from '@mui/material/Chip';
import CancelIcon from "@pixel/assets/icons/Cancel";
import { useTheme } from '../styles';
const PixelChip = _ref => {
  let {
    label,
    color,
    variant,
    avatar,
    icon,
    size,
    title,
    onClick = null,
    onDelete = null,
    sx
  } = _ref;
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(Chip, _extends({
    label: label,
    color: color,
    size: size,
    avatar: avatar,
    icon: icon,
    title: title,
    variant: variant,
    "aria-label": label
  }, Boolean(onClick) && {
    onClick
  }, Boolean(onDelete) && {
    onDelete
  }, {
    sx: {
      ...theme.typography.overline,
      ...sx
    },
    deleteIcon: /*#__PURE__*/React.createElement(CancelIcon, {
      sx: {
        color: '#5B6971!important',
        fontSize: "16px!important"
      },
      "aria-label": label
    })
  }));
};
export default PixelChip;